import { useEffect } from 'react';

type Props = {
  title?: string;
  description?: string;
};

const SITE = 'Vertex Paints';

/**
 * Sets the document title and meta description for a page. Keep titles short —
 * the site name is appended automatically.
 */
const Seo = ({ title, description }: Props) => {
  useEffect(() => {
    document.title = title ? `${title} | ${SITE}` : `${SITE} — Premium Interior & Exterior Paints`;
    if (description) {
      let tag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.name = 'description';
        document.head.appendChild(tag);
      }
      tag.content = description;
    }
  }, [title, description]);
  return null;
};

export default Seo;
